import { jsonToHtml as x } from "@contentstack/json-rte-serializer";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.every.js";
import "core-js/modules/esnext.iterator.some.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
const v = (t, e, s = !1) => e != null && e.includes(t) ? e : `${e}${s ? " " : ""}${t}`, u = (t, e = "") => {
  const s = e == null ? void 0 : e.indexOf(`${t}="`);
  return s === -1 || e === null ? "" : e.substring(s).split('"')[1];
}, y = (t, e, s, r = !1) => e !== "" && (s != null && s.includes(e)) ? s == null ? void 0 : s.replace(e, t) : `${s}${r ? " " : ""}${t}`, b = (t, e = "") => e.replace(`${t}="${u(t, e)}"`, "").trim(), D = (t, e) => {
  let s = e || "";
  return (t || []).forEach((r) => {
    s = b(r, s);
  }), s;
}, h = ["height", "width"], A = "56.25%", H = "https://www.rei.com/dam/placeholder.gif", E = (t) => {
  const e = t ? `${t}` : "";
  return e.slice(e.length - 1) === "%";
}, I = (t, e, s, r) => !E(t) && !E(e) && (s == null ? void 0 : s.includes(`${r}%`)), L = (t, e) => {
  const {
    "redactor-attributes": s = {}
  } = t || {};
  let r = e;
  return h.forEach((i) => {
    const o = t == null ? void 0 : t[i], c = `${i}: ${o}`;
    r = I(o, s == null ? void 0 : s[i], r, c) ? r.replace(`${c}%`, `${c}px`) : r, r = r && r.replace(new RegExp(`${i}: ([0-9]+);`), `${i}: $1px;`);
  }), r;
}, M = (t = "") => {
  let e = t;
  return h.forEach((s) => {
    const r = u(s, t).replace("%", "");
    r !== "" && (e = e.replace(`${s}="${r}%"`, `${s}="${r}"`));
  }), e;
}, T = (t) => h.every((e) => !(t != null && t.includes(`${e}="`)) && !(t != null && t.includes(`${e}:`))), F = (t, e) => t ? `<figcaption ${e ? 'style="text-align: center;"' : ""}>${t}</figcaption>` : "", U = {
  img: (t, e, s) => {
    const {
      attrs: r = {}
    } = s || {}, {
      id: i,
      anchorLink: o,
      target: c,
      caption: n,
      "redactor-attributes": a,
      style: {
        "text-align": l
      } = {}
    } = r;
    let d = L(r, b("url", t)) || "";
    const {
      style: $
    } = a || "";
    if (d && $) {
      const p = u("style", d);
      d = p ? y(`${p} ${$}`, p, d) : y(`style="${$}"`, "", d, !0);
    }
    const m = o ? `<a${i ? ` id="${i}"` : ""} href="${o}"${c ? ` target="${c}"` : ""}><img ${d}/></a>` : `<img${i ? ` id="${i}"` : ""} ${d}/>`, f = F(n, l === "center");
    return f === "" ? `${m}` : `<figure>${m}${f}</figure>`;
  }
}, C = 360, w = 640, _ = `position:relative;padding-bottom:${A};`, O = (t) => {
  let e = t || "";
  const s = h.some((r) => e.includes(`${r}: auto`));
  return h.forEach((r) => {
    e = e.replace(`${r}: auto`, `${r}: 100%`);
  }), e = v("border: none;", e), s && (e = v("position: absolute;", e)), {
    styleValue: e,
    isRelative: s
  };
}, P = "htmlVideo", j = (t, e) => {
  const s = u("src", t), {
    type: r = ""
  } = e || "";
  let i = (b("src", b(P, t)) || "").trim();
  return Object.entries(e).forEach((o) => {
    var c;
    o[0] === "options" ? i = `${(c = o[1]) == null ? void 0 : c.join(" ")} ${i}` : o[0] !== "type" && (i += ` ${o[0]}="${o[1]}"`);
  }), `<video ${i}><source src="${s}" type="${r}"/></video>`;
}, N = {
  embed: (t, e, s) => {
    const {
      attrs: r = {}
    } = s || {};
    if (P in r) {
      const {
        htmlVideo: a = {}
      } = r || {};
      return j(t, a);
    }
    const i = u("style", t), {
      styleValue: o,
      isRelative: c
    } = O(L(r, i));
    let n = t ? y(`style="${o}"`, `style="${i}"`, t.trim(), !0) : "";
    return n && T(n) && (n = `${n.trim()} width="${w}" height="${C}"`), n ? `<div style="${c ? `${_}` : ""}overflow:hidden;"><iframe ${n}></iframe></div>` : "";
  }
}, g = (t = [], e = "") => t.find((s) => (s == null ? void 0 : s.renditionName) && s.renditionName.toLowerCase() === e.toLowerCase()) || {}, k = (t = {}) => {
  var o;
  const {
    publicLinks: e
  } = t, s = (e || []).filter((c) => c == null ? void 0 : c.onlinePublishLink), {
    onlinePublishLink: r
  } = g(s, "Web_xs"), {
    onlinePublishLink: i
  } = g(s, "downloadOriginal");
  return r || i || ((o = s[0]) == null ? void 0 : o.onlinePublishLink) || "";
}, q = (t, e) => {
  const s = t && e;
  return t || e ? `<figcaption>${t || ""}${s ? "<br/>" : ""}${e ? `<cite>${e}</cite>` : ""}</figcaption>` : "";
}, W = {
  "asset-embed": (t, e, s) => {
    const {
      attrs: r = {}
    } = s || {}, {
      id: i,
      asset: o = {}
    } = r, {
      caption: c,
      attribution: n,
      altText: a
    } = o, l = k(o);
    l || console.error("asset-embed cannot be rendered due to missing Online Publish Link! Review the asset in DAM", o);
    const d = `<img${i ? ` id="${i}"` : ""} src="${l}" alt="${a || ""}" style="max-width:100%; height:auto;"/>`, $ = q(c, n);
    return $ ? `<figure style="margin-block-start:0;margin-block-end:0;margin-inline-start:0;margin-inline-end:0;">${d}${$}</figure>` : d;
  }
}, G = {
  "video-embed": (t, e, s) => {
    const r = u("src", t) !== "", i = u("style", t), o = u("responsiveVideo", t) === "true", {
      attrs: {
        id: c
      } = {}
    } = s || {}, {
      styleValue: n,
      isRelative: a
    } = O(i);
    let l = "";
    return r ? (l = M(t), l = D(["responsiveVideo", "showControls", "dir"], l), l = y(`style="${n}"`, `style="${i}"`, l.trim(), !0), l = T(l) ? `${l.trim()} width="${w}" height="${C}"` : l) : console.error('video-embed cannot be rendered due to missing "src" attribute. Check Contentstack entry', t), l ? `<div${c ? ` id="${c}"` : ""} class="${o ? "rei-cms__video-responsive" : "rei-cms__video"}" style="${a ? `${_}` : ""}overflow:hidden;"><iframe ${l}></iframe></div>` : "";
  }
}, S = (t = []) => {
  let e = "";
  return t.forEach((s) => {
    e = `${e.trim()} ${s.trim()}`.trim();
  }), e;
}, K = {
  "html5-video-embed": (t, e, s) => {
    const {
      attrs: {
        id: r,
        autoPlay: i,
        description: o,
        loop: c,
        muted: n,
        playsInline: a,
        poster: l,
        preload: d,
        showControls: $,
        src: m
      } = {}
    } = s || {};
    m || console.error('html5-video-embed is missing the required "src" attribute. Check Contentstack entry');
    const f = ['class="rei-cms__html5-video"', $ ? "controls" : "", i ? "autoplay" : "", a ? "playsinline" : "", c ? "loop" : "", n ? "muted" : "", `preload="${d || ""}"`, `poster="${l || H}"`, o ? `aria-label="${o}"` : ""], p = S(f), V = `<p>Your browser doesn't support HTML video. Here is a <a href="${m}">link to the video</a> instead.</p>`;
    return `<div${r ? ` id="${r}"` : ""} class="rei-cms__html5-video-wrapper"><video ${p}><source src="${m}" />${V}</video></div>`;
  }
}, R = {
  CTAEntryList: []
}, Q = (t) => ["uid", "title", "href"].every((e) => Object.hasOwn(t, e)), re = (t) => {
  const e = t || [];
  e.length > 0 && !Q(e[0]) && console.error('CTA Entries will not render correctly! Entries are missing at least one of the required property keys: "uid", "title", and/or "href"'), R.CTAEntryList = [...e];
}, X = {
  reference: (t, e, s) => {
    const {
      attrs: {
        id: r,
        "content-type-uid": i,
        "entry-uid": o,
        "display-type": c
      } = {}
    } = s || {};
    if (i !== "cta")
      return t;
    const n = R.CTAEntryList.find((l) => o === (l == null ? void 0 : l.uid));
    n || console.warn(`Could not find CTA Entry with UID "${o}". Confirm entry "${o}" has been published and that all embedded entries are included in the GraphQL query.`);
    const a = `rei-cms__cta${c ? `--${c}` : ""}${n != null && n.isSecondary ? " rei-cms__cta--secondary" : ""}`;
    return n ? `<a${r ? ` id="${r}"` : ""} class="${a}" data-cta-uid="${o}" href="${n == null ? void 0 : n.href}">${n == null ? void 0 : n.title}</a>` : "";
  }
}, Y = (t = {}, e = {}) => {
  const s = {
    customElementTypes: {
      ...U,
      ...N,
      ...W,
      ...G,
      ...K,
      ...X,
      ...t
    }
  };
  return e !== null && Object.keys(e).length > 0 && (s.customTextWrapper = {
    ...e
  }), s;
}, ie = (t = null, e = {}, s = {}) => t === null ? "" : x(t, Y(e, s));
export {
  ie as default,
  re as setCTAEntries
};
